import BikeIcon from "../../Assets/images/motor-bike-icon.png";
import RikshaIcon from "../../Assets/images/riksha-icon.png";
import HmvIcon from "../../Assets/images/hmv-icon.png";

export default function DLVehicleClassTable({ driving_license_data }) {
  const rtoCode =
    String(driving_license_data?.dlNumber).substring(0, 4).toUpperCase() || "";

  const dateOfIssue =
    driving_license_data?.validity?.non_transport?.issue_date || "";

  const vehicleRows = driving_license_data?.vehicle_class_details || [];

  return (
    <div className="border border-gray-300 overflow-hidden w-full max-w-4xl bg-white">
      <table className="w-full border-collapse text-[7px] font-bold">
        <thead>
          <tr className="bg-[#C7E7F4] text-gray-800 text-center font-bold">
            <th className="border border-gray-300 px-1 py-0.5">
              <span className="relative -top-[6px]">
                Class of
                <br /> Vehicle
              </span>
            </th>
            <th className="border border-gray-300 px-1 py-0.5">
              <span className="relative -top-[6px]">Code</span>
            </th>
            <th className="border border-gray-300 px-1 py-0.5">
              <span className="relative -top-[6px]">Issued by</span>
            </th>
            <th className="border border-gray-300 px-1 py-0.5">
              <span className="relative -top-[6px]">
                Date of
                <br /> Issue
              </span>
            </th>
            <th className="border border-gray-300 px-1 py-0.5">
              <span className="relative -top-[6px]">
                Vehicle <br />
                Category
              </span>
            </th>
            <th className="border border-gray-300 px-1 py-0.5">
              <span className="relative -top-[6px]">
                Badge <br />
                Number
              </span>
            </th>
            <th className="border border-gray-300 px-1 py-0.5">
              <span className="relative -top-[6px]">
                Badge <br />
                Issued Date
              </span>
            </th>
            <th className="border border-gray-300 px-1 py-0.5">
              <span className="relative -top-[6px]">
                Badge <br />
                Issued by
              </span>
            </th>
          </tr>
        </thead>

        <tbody>
          {vehicleRows.map((v, index) => (
            <tr key={index} className="text-center">
              {/* Class of vehicle icon */}
              <td className="border border-gray-300 px-1 py-0.5">
                {v.category === "MCWG" ? (
                  <span className="text-[7px]">
                    <img src={BikeIcon} className="w-3 mx-auto" />
                  </span>
                ) : v.category === "LMV" ? (
                  <span className="text-[7px]">
                    <img
                      src="data:image/png;base64,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"
                      className="w-3 mx-auto"
                    />
                  </span>
                ) : v.category === "eRIKSH" ? (
                  <span className="text-[7px]">
                    <img src={RikshaIcon} className="w-3 mx-auto" />
                  </span>
                ) : v.category === "HMV" ? (
                  <span className="text-[7px]">
                    <img src={HmvIcon} className="w-3 mx-auto" />
                  </span>
                ) : (
                  <span className="text-[7px]">•</span>
                )}
              </td>

              {/* Code */}
              <td className="border border-gray-300 px-1 py-0.5 font-bold">
                <span className="relative -top-[5px]">{v.category}</span>
              </td>

              {/* Issued By (extract region code if required) */}
              <td className="border border-gray-300 px-1 py-0.5">
                <span className="relative -top-[5px]">
                  {rtoCode.replace("RTO,", "").trim()}
                </span>
              </td>

              {/* Date of Issue */}
              <td className="border border-gray-300 px-1 py-0.5">
                <span className="relative -top-[5px]">{dateOfIssue}</span>
              </td>

              {/* Vehicle Category */}
              <td className="border border-gray-300 px-1 py-0.5 font-bold">
                <span className="relative -top-[5px]">NT</span>
              </td>

              {/* Badge fields empty */}
              <td className="border border-gray-300 px-1 py-0.5"></td>
              <td className="border border-gray-300 px-1 py-0.5"></td>
              <td className="border border-gray-300 px-1 py-0.5"></td>
            </tr>
          ))}

          {/* Add 3-4 blank rows like shown */}
          {[...Array(3)].map((_, i) => (
            <tr key={`blank-${i}`}>
              {Array.from({ length: 8 }).map((_, j) => (
                <td
                  key={j}
                  className="border border-gray-300 h-3 text-center"
                ></td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
